import { Box } from "@bvhi/ui-base";
import { useMemo } from "react";
import { completeStringDate } from "../../../helpers/date";

interface Props {
  date: string | undefined;
  fallBack?: string;
}

export const DateCell = ({ date, fallBack }: Props) => {
  const dateString = useMemo(() => {
    const value = completeStringDate(date);
    if (!value) return fallBack;
    return value;
  }, [date, fallBack]);

  if (!dateString && fallBack) return <Box>{fallBack}</Box>;
  if (!dateString && !fallBack) return null;

  return <Box>{dateString}</Box>;
};
